export class PLAuctionEntry {
  Ind: number;
  OrgCode: number;
  CityCode: number;
  DeptCode: number;
  OfficerCode: number;
  ZoneCode: number;
  AuctionNo: string;
  AuctionPublishDate: string;
  AuctionAuthorityCd: number;
  AuctionTypeCd: number;
  AuctionSubTypeCd: number;
  AuctionTitle: string;
  AuctionLocation: string;
  AuctionDetail: string;
  Description: string;
  AuctionAmt: string;
  StartingPrice: string;
  AuctionFee: string;
  ContactPersonName: string;
  ContactMobileNo: string;
  RegistrationDateFrom: string;
  RegistrationDateTo: string;
  RegistrationStarttime: string;
  RegistrationEndtime: string;
  EMDAmt: string;
  EMDSubimissionStartDate: string;
  EMDSubimissionStarttime: string;
  EMDSubimissionEndDate: string;
  EMDSubimissionEndtime: string;
  AuctionStartDate: string;
  AuctionStartTime: string;
  AuctionEndDate: string;
  AuctionEndTime: string;
  FinalAuctionEndTime: string;
  IncrementalAmt: string;
  BiddingTypeId: number;
  AuctionPeriod: number;
  UserId: number;
  DocumentList: any = [];
  // change 04-07-2020
  ParticipationDocsList: any = [];
  // For Updation
  AuctionId: number;
  ParticipationVerificationInd: number;

  // For Verification 21-08-2020
  DAUserId: number;
  ROUserId: number;
  DCUserId: number;
  //09-02-2021
  WinnerShowInd: number;
  AllowedExemptionInd: number;

  LatLongInd: number;
  Longitude: string;
  Latitude: string;

  AllowExtInd: number;
  Allowautoextension: string;
  checkforextension: string;
  AutoExtensionTime: string;
  AutoExtensionlimit: string;

  //EndDateInd: number;
}
